import orderBy from '@util/orderBy';
import { createStore } from 'cross-state';
import { createContext } from 'react';

export const TitleDepth = createContext(0);

export const titleStore = createStore(new Set<{ depth: number; title: string }>());

export function getTitle(items: Set<{ depth: number; title: string }>) {
  return orderBy([...items], (x) => x.depth, 'desc')[0]?.title;
}

export function useTitle() {
  return titleStore.useStore(getTitle);
}
